#import "../fragments/EmailBlockFields.graphql"

mutation CreateEmailTemplate($input: EmailTemplateInput!) {
  createEmailTemplate(input: $input) {
    id
    name
    updatedAt
    variants {
      language
      subject
      preheader
      blocks {
        ...EmailBlockFields
      }
    }
  }
}
